import Application from "../Application";
import Area, { IArea } from "./Area";
import { IRouter } from "../runtime/Router";
import ShowPortalReportingPeriodInteractor from "../interactor/portal/ShowPortalReportingPeriodInteractor";
import PortalFormDetailsPage from "../ui/pages/portal/PortalFormDetailsPage";
import ShowPortalFormDetailsInteractor from "../interactor/portal/ShowPortalFormDetailsPageInteractor";
import PortalReportingPeriodPage from "../ui/pages/portal/PortalReportingPeriodPage";

export default class PortalReportingArea extends Area implements IArea {
  private application: Application;
  private router: IRouter;

  constructor(application: Application, router: IRouter) {
    super();
    this.application = application;
    this.router = router;
  }

  register(params: any) {
    this.router.registerRoutes(
      {
        path: "/reporting-periods/:reporting_period_id",
        page: this.createPage({
          Page: PortalReportingPeriodPage,
          action: this.showPortalReportingPeriodPage.bind(this)
        }),
        options: {
          secure: false
        }
      },
      {
        path: "/forms/:formId",
        page: this.createPage({
          Page: PortalFormDetailsPage,
          action: this.showPortalFormDetailsPage.bind(this)
        }),
        options: {
          secure: false
        }
      }
    );
  }

  public showPortalReportingPeriodPage(params: any) {
    return this.application.container
      .resolve<ShowPortalReportingPeriodInteractor>(
        "showPortalReportingPeriods"
      )
      .execute(params.reporting_period_id);
  }

  public showPortalFormDetailsPage(params: any) {
    return this.application.container
      .resolve<ShowPortalFormDetailsInteractor>("showPortalFormDetails")
      .execute(params.formId);
  }
}
